/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PremiumScheduleAllocationDto
 */
export interface PremiumScheduleAllocationDto {
    /**
     * Premium schedule ID
     * @type {string}
     * @memberof PremiumScheduleAllocationDto
     */
    premiumScheduleId: string;
    /**
     * Settlement exchange rate
     * @type {string}
     * @memberof PremiumScheduleAllocationDto
     */
    settlementExchangeRate: string;
}

/**
 * Check if a given object implements the PremiumScheduleAllocationDto interface.
 */
export function instanceOfPremiumScheduleAllocationDto(value: object): value is PremiumScheduleAllocationDto {
    if (!('premiumScheduleId' in value) || value['premiumScheduleId'] === undefined) return false;
    if (!('settlementExchangeRate' in value) || value['settlementExchangeRate'] === undefined) return false;
    return true;
}

export function PremiumScheduleAllocationDtoFromJSON(json: any): PremiumScheduleAllocationDto {
    return PremiumScheduleAllocationDtoFromJSONTyped(json, false);
}

export function PremiumScheduleAllocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumScheduleAllocationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'premiumScheduleId': json['premiumScheduleId'],
        'settlementExchangeRate': json['settlementExchangeRate'],
    };
}

export function PremiumScheduleAllocationDtoToJSON(json: any): PremiumScheduleAllocationDto {
    return PremiumScheduleAllocationDtoToJSONTyped(json, false);
}

export function PremiumScheduleAllocationDtoToJSONTyped(value?: PremiumScheduleAllocationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'premiumScheduleId': value['premiumScheduleId'],
        'settlementExchangeRate': value['settlementExchangeRate'],
    };
}

